import type { ExternalDepartmentFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (
  item: ExternalDepartmentFragment,
): IMultiSelectItem => {
  return {
    id: item.id,
    title: [item.institution.name, item.name]
      .filter((element) => {
        return element !== null && element !== undefined;
      })
      .join(" - "),
    svg: "fas-house",
    iconBackground: item.color || undefined,
    svgStyle: "circle",
  };
};

const toOption = (item: ExternalDepartmentFragment): IOption => {
  return {
    value: item.id,
    title: [item.institution.name, item.name]
      .filter((element) => {
        return element !== null && element !== undefined;
      })
      .join(" - "),
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
